const BLACK = 'black';
const WHITE = 'white';

let oppositeColor = c => c === BLACK ? WHITE : BLACK;

export { BLACK, WHITE, oppositeColor }



// WEBPACK FOOTER //
// ./src/game/color.js